import script from "./chanping-1.vue?vue&type=script&setup=true&lang=js"
export * from "./chanping-1.vue?vue&type=script&setup=true&lang=js"

import "./chanping-1.vue?vue&type=style&index=0&id=6a10d9c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a10d9c6"]])

export default __exports__